/**
 * Region Constants
 *
 * Shared constants for antibody sequence regions (FWR and CDR)
 */

/**
 * Region order configuration
 *
 * Defines the standard order of (FWR) and
 * (CDR) in antibody sequences
 */
export const REGION_ORDER = [
  { key: 'fwr1', label: 'FWR1', isCDR: false },
  { key: 'cdr1', label: 'CDR1', isCDR: true },
  { key: 'fwr2', label: 'FWR2', isCDR: false },
  { key: 'cdr2', label: 'CDR2', isCDR: true },
  { key: 'fwr3', label: 'FWR3', isCDR: false },
  { key: 'cdr3', label: 'CDR3', isCDR: true },
  { key: 'fwr4', label: 'FWR4', isCDR: false },
] as const;

/**
 * Type helper for region keys
 */
export type RegionKey = (typeof REGION_ORDER)[number]['key'];
